import React, { FC } from 'react';
import { useTranslation, useWindowSize } from 'mycheck-core';
import { useFormikContext } from 'formik';
import classNames from 'classnames';

import {
  CustomButton,
  CustomInput,
  CustomPhoneInput,
  Icon,
  Loader,
  Overlay,
} from '@components';

import { ContactRowForm, NotificationType } from '../OrderStatusNotifications';
import styles from './NotificationModal.module.scss';

interface NotificationModalProps {
  notificationType: `${NotificationType}`;
  label: string;
  close: () => void;
}

export const NotificationModal: FC<NotificationModalProps> = ({
  label,
  close,
  notificationType,
}) => {
  const { isLg } = useWindowSize();
  const modalWidth = isLg ? 480 : '100%';

  const { t } = useTranslation();

  const onCloseNotificationModal = () => {
    close();
  };

  const formikProps = useFormikContext<ContactRowForm & { phone?: string }>();
  const { value } = formikProps.values[notificationType];
  return (
    <Overlay
      width={modalWidth}
      testId={`${label}-change-notification`}
      onClickOutside={onCloseNotificationModal}
      paperStyle={{
        maxHeight: 390,
        maxWidth: modalWidth,
        position: 'absolute',
        bottom: 0,
        borderRadius: 16,
      }}
    >
      <div className={styles.notificationModal}>
        <div className={styles.notificationModalForm}>
          <div className={styles.notificationModalFormHeader}>
            {label} {t('orderStatus.notification.title')}
            <div
              className={classNames(styles.notificationModalFormHeaderExit)}
              onClick={onCloseNotificationModal}
            >
              <Icon name="x" />
            </div>
          </div>
          <p className={styles.notificationModalFormDescription}>
            {t(
              `orderStatus.notification.description.${notificationType.toLowerCase()}`,
            )}
          </p>
          {notificationType === NotificationType.SMS && (
            <CustomPhoneInput
              testId="phone-number-screen"
              fieldName={`${notificationType}.value`}
              formikProps={formikProps}
              placeholder={t('profile.phonePlaceholder')}
            />
          )}
          {notificationType === NotificationType.EMAIL && (
            <CustomInput
              onChange={formikProps.handleChange}
              type="email"
              value={value}
              name={`${notificationType}.value`}
              placeholder={t('orderStatus.notification.emailPlaceholder')}
              error={!!formikProps.errors[notificationType]?.value}
              errorMessage={formikProps.errors[notificationType]?.value}
            />
          )}
          {formikProps.isSubmitting && <Loader />}
          <CustomButton
            text={t('orderStatus.notification.buttonSubmit')}
            type="submit"
            className={styles.notificationModalFormButton}
            testId="confirm-done"
            disabled={formikProps.isSubmitting}
          />
        </div>
      </div>
    </Overlay>
  );
};
